<template>
  <div class="customer-wrp">
    <FormList
      :list="formList"
      :data="addressInfo"
      :onChange="onInputChange"
    />
    <ButtonRow
      :firstText="this.$route.params.type === 'edit' ? '删 除' : '返 回'"
      :firstClick="this.$route.params.type === 'edit' ? deleteAddress : goBack"
      :secondClick="confirm"
      :bottom="true"
    />
  </div>
</template>

<script>
import { customerRequest } from '@services'
import {
  Row,
  Button,
  Notify
} from 'vant'
import { isEmail } from '@utils/basicUtil'
import FormList from '@components/FormList'
import ButtonRow from '@components/ButtonRow'

export default {
  data () {
    return {
      addressInfo: {
        userName: '',
        address: '',
        telephone: '',
        email: '',
        defaultFlag: false,
        merchantId: ''
      },
      formList: [
        {
          type: 'text',
          field: 'userName',
          label: '收件人',
          placeholder: '输入客户联系人姓名'
        },
        {
          type: 'text',
          field: 'address',
          label: '收件地址',
          placeholder: '输入客户收件地址'
        },
        {
          type: 'text',
          field: 'telephone',
          label: '电话',
          placeholder: '输入客户联系电话'
        },
        {
          type: 'text',
          field: 'email',
          placeholder: '请输入电票收件邮箱',
          label: '邮箱'
        },
        {
          type: 'switch',
          field: 'defaultFlag',
          label: '设为默认'
        }
      ]
    }
  },
  watch: {
  },
  mounted () {
    if (this.$route.params.type === 'edit') {
      this.addressInfo.id = this.$route.query.id
      this.getAddressDetail(this.$route.query.id)
    }
    this.addressInfo.merchantId = this.$route.query.merchantId
  },
  methods: {
    onInputChange ({ e, field }) {
      this.addressInfo[field] = e
    },
    async getAddressDetail (id) {
      const data = await customerRequest.address.getAddressDetail({ id })
      if (data.success) {
        this.addressInfo = {
          ...data.result,
          defaultFlag: data.result.defaultFlag === 0
        }
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    cancel () {
      this.$router.go(-1)
    },
    async deleteAddress () {
      const data = await customerRequest.address.addOrEdit({ addresseeInfoRequestList: [{ id: this.$route.query.id, deleteFlag: 1 }] })
      if (data.success) {
        Notify({ type: 'success', message: '删除成功！' })
      } else {
        Notify({ type: 'danger', message: data.message })
      }
      this.cancel()
    },
    goBack () {
      this.$router.go(-1)
    },
    async confirm () {
      let addressInfo = this.addressInfo
      if (!isEmail(addressInfo.email)) {
        return Notify({ type: 'danger', message: '邮箱格式不正确' })
      }
      if (addressInfo.telephone.trim().length === 0) {
        return Notify({ type: 'danger', message: '联系电话不能为空' })
      }
      if (addressInfo.userName.trim().length === 0) {
        return Notify({ type: 'danger', message: '联系人不能为空' })
      }
      if (addressInfo.address.trim().length === 0) {
        return Notify({ type: 'danger', message: '收件地址不能为空' })
      }
      this.addressInfo.defaultFlag = this.addressInfo.defaultFlag ? 0 : 1
      if (this.$route.params.type === 'edit') {
      } else if (this.$route.params.type === 'add') {
        delete addressInfo.id
      }
      const data = await customerRequest.address.addOrEdit({ addresseeInfoRequestList: [this.addressInfo] })
      if (data.success) {
        Notify({ type: 'success', message: '保存成功！' })
        this.cancel()
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    }
  },
  components: {
    ButtonRow,
    FormList,
    [Row.name]: Row,
    [Button.name]: Button
  }
}
</script>

<style lang="less" scoped src="./style.less"/>
